"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.handleMessage = void 0;var _browser = require("./utils/browser");
var _commands = require("./commands");
var _eventHandlers = require("./eventHandlers");
var _clientState = require("./utils/clientState");
var _callbacks = require("./utils/callbacks");
var _url = require("./utils/url");
var _const = require("./const");



var _logging = require("./utils/logging");
var _activityWatcher = require("./activityWatcher");

/**
 * handles a postMessage event from auth components
 * @param {MessageEvent} message - expected to be a Message Event Object https://developer.mozilla.org/en-US/docs/Web/API/MessageEvent
 * @param message.data - expected to be an auth command object https://flash-team.atlassian.net/wiki/spaces/ENG/pages/3675389953/Unified+Login+Authentication+Components+API#Command-Object.3
 * @param config
 * @param state
 */
const handleMessage = (message, config, state) => {
  const responseMessage = message.data;
  _logging.Logger.debug("Message Received", JSON.stringify(responseMessage, null, 2));

  // handle invalid communication
  if (!(responseMessage !== null && responseMessage !== void 0 && responseMessage.response)) {
    return;
  }

  const { id, success, isAuthenticated, authentication, currentUser } = responseMessage.responseDetails;

  if (currentUser) {var _state$currentUser, _state$currentUser$ac;
    Object.freeze(currentUser);
    state.currentUser = currentUser;

    //If we have an account policy on the user, we will turn on Auto Logout forcefully
    const policy = state === null || state === void 0 ? void 0 : (_state$currentUser = state.currentUser) === null || _state$currentUser === void 0 ? void 0 : (_state$currentUser$ac = _state$currentUser.accountPolicy) === null || _state$currentUser$ac === void 0 ? void 0 : _state$currentUser$ac.policy;
    if (policy !== null && policy !== void 0 && policy.logoutAfterInactivityMinutes) {
      config.options.autoLogout = true;
      config.options.autoLogoutInMinutes = policy.logoutAfterInactivityMinutes;
      config.options.autoLogoutWarningMinutes = policy.logoutInactivityWarningMinutes;
      _activityWatcher.ActivityWatcher.start(policy.logoutAfterInactivityMinutes, policy.logoutInactivityWarningMinutes);
      _logging.Logger.debug("turning on ActivityWatcher for Auto Logout", policy);
    }
  }

  // This clientState was encoded outbound by this client. The Portal SSO will pass back
  // the encoded clientState (untouched). So if it exists, we'll decode it
  // We will try to pull from the QS first, because it was a redirect. If we don't have state on the QS, we'll
  // lock for it in the response
  const qsState = (0, _url.getValueFromQueryString)(_const.QS_STATE);
  const encodedClientState = qsState || (0, _clientState.encode)(responseMessage.responseDetails.clientState);
  if (qsState) {
    responseMessage.responseDetails.clientState = (0, _clientState.decodeAndParse)(encodedClientState);
  }

  switch (responseMessage.response) {
    case _commands.Command.CommandResponses.initialized:
      config.clientPortals = responseMessage.responseDetails.clientPortals;
      (0, _callbacks.makeCallbacks)(id, config.callbacks, responseMessage);
      break;
    case _commands.Command.CommandResponses.changePassword:
    case _commands.Command.CommandResponses.checkAuthentication:
    case _commands.Command.CommandResponses.redeemCode:
    case _commands.Command.CommandResponses.refreshTokens:
    case _commands.Command.CommandResponses.updateProfile:
      if (success && isAuthenticated && authentication) {
        (0, _eventHandlers.handleAuthenticationUpdated)(authentication);
      }
      (0, _callbacks.makeCallbacks)(id, config.callbacks, responseMessage);
      break;
    case _commands.Command.CommandResponses.logout:
      if (success) {
        state.clearAuthentication();
      }
      (0, _callbacks.makeCallbacks)(id, config.callbacks, responseMessage);
      break;
    case _commands.Command.CommandResponses.navigateParent:
      if (success) {
        const to = responseMessage.responseDetails.to;
        (0, _browser.launchUri)(to);
      }
      break;
    case _commands.Command.CommandResponses.redirectToLogin:
      (0, _commands.authorizeCommand)(config, undefined, encodedClientState);
      break;
    case _commands.Command.CommandResponses.logoutWarning:
      (0, _callbacks.makeCallbacks)(id, config.callbacks, responseMessage);
      break;
    default:
      _logging.Logger.debug('Invalid message response received', responseMessage);
      break;
  }
};exports.handleMessage = handleMessage;